import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';

@Injectable({
  providedIn: 'root'
})
export class AppcolorService {



  constructor(private http: HttpClient, private global: Globle, private localStorage: LocalStorageService) {


  }

  get() {
    return this.http.get<any>(this.global.APIURL + "appColors");
  }

  Update(appColors: any) {
    return this.http.post(this.global.APIURL + "appColors", appColors)
  }

  getAvailableProductCards() {
    return this.http.get<any>(this.global.APIURL + "productcards/getavailable");
  }
}
